export default __webpack_public_path__ + "static/media/vivianethompson.fee3d525.png";